export default __webpack_public_path__ + "static/media/Khelo Cross Hamburger.f72c54ee.svg";